import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import Features from './Features';
import Footer from './Footer';
import SignInModal from './SignInModal';
import PricingModal from './PricingModal';
import PacerModal from './PacerModal';

const Home = () => {
  const [signInOpen, setSignInOpen] = useState(false);
  const [pricingOpen, setPricingOpen] = useState(false);
  const [pacerOpen, setPacerOpen] = useState(false);

  useEffect(() => {
    document.title = 'Steno | PACE MASTER — Real-Time Courtroom Cadence Pacer';
  }, []);

  return (
    <>
      <div className="pointer-events-none fixed inset-0 hero-radial" />
      <Navbar onSignIn={() => setSignInOpen(true)} />
      <main className="relative z-10">
        <Hero
          onStart={() => setPacerOpen(true)}
          onPricing={() => setPricingOpen(true)}
        />
        <Features />
      </main>
      <Footer />

      <SignInModal open={signInOpen} onClose={() => setSignInOpen(false)} />
      <PricingModal open={pricingOpen} onClose={() => setPricingOpen(false)} />
      <PacerModal open={pacerOpen} onClose={() => setPacerOpen(false)} onPricing={() => { setPacerOpen(false); setPricingOpen(true); }} />
    </>
  );
};

export default Home;
